export class Status {
  loading: boolean;
  errorMsg: string;

  authLoading: boolean;
  authErrorMsg: string;

  //#region API KEYS
  getApiKeysLoading: boolean = false;
  createApiKeysLoading: boolean = false;
  deleteApiKeysLoading: boolean = false;
  apiKeysErrorMsg: string = '';
  //#endregion

  //#region Artikel
  getArtikelLoading: boolean;
  artikelErrorMsg: string;
  //#endregion

  //#region Bestand
  getBestandLoading: boolean;
  bestandErrorMsg: string;
  //#endregion

  bestellungenLoading: boolean;
  bestellungenErrorMsg: string;
  updateBestellungenLoading: boolean;
  updateBestellungenErrorMsg: string;

  getBestellungPalettenLoading: boolean;
  updateBestellungPalettenLoading: boolean;
  getBestellungDocLoading: boolean;
  bestellungPalettenErrorMsg: string;

  getUmfuhrPalettenLoading: boolean;
  updateUmfuhrPalettenLoading: boolean;
  umfuhrPalettenErrorMsg: string;

  getUmfuhrLoading: boolean;
  createUmfuhrLoading: boolean;
  updateUmfuhrLoading: boolean;
  deleteUmfuhrLoading: boolean;
  umfuhrErrorMsg: string;

  getUmfuhrposLoading: boolean;
  createUmfuhrposLoading: boolean;
  updateUmfuhrposLoading: boolean;
  deleteUmfuhrposLoading: boolean;
  umfuhrposErrorMsg: string;

  sidebarCollapsed: boolean;

  constructor() {
    this.loading = false;
    this.errorMsg = '';

    this.authLoading = false;
    this.authErrorMsg = '';

    //#region Artikel
    this.getArtikelLoading = false;
    this.artikelErrorMsg = '';
    //#endregion

    //#region Bestand
    this.getBestandLoading = false;
    this.bestandErrorMsg = '';
    //#endregion

    //#region Bestellung
    this.bestellungenLoading = false;
    this.bestellungenErrorMsg = '';
    this.updateBestellungenLoading = false;
    this.updateBestellungenErrorMsg = '';

    this.getBestellungPalettenLoading = false;
    this.updateBestellungPalettenLoading = false;
    this.getBestellungDocLoading = false;

    this.bestellungPalettenErrorMsg = '';
    //#endregion
    this.sidebarCollapsed = false;

    //#region Umfuhr
    this.getUmfuhrLoading = false;
    this.createUmfuhrLoading = false;
    this.updateUmfuhrLoading = false;
    this.deleteUmfuhrLoading = false;
    this.umfuhrErrorMsg = '';

    this.getUmfuhrposLoading = false;
    this.createUmfuhrposLoading = false;
    this.updateUmfuhrposLoading = false;
    this.deleteUmfuhrposLoading = false;
    this.umfuhrposErrorMsg = '';

    this.getUmfuhrPalettenLoading = false;
    this.updateUmfuhrPalettenLoading = false;
    this.umfuhrPalettenErrorMsg = '';
    //#endregion
  }
}

export interface ErrorResponseData {
  detail: string;
  status: number;
  title: string;
  type: string;
}
